function initRoomGallery(container) {
    const gallery = container.querySelector('[data-gallery]');
    if (!gallery) return;

    const images = gallery.querySelectorAll('img');
    if (images.length <= 1) return;

    const counter = gallery.querySelector('[data-gallery-counter]');
    let current = 0;

    function goTo(index) {
        images[current].classList.replace('opacity-100', 'opacity-0');
        current = (index + images.length) % images.length;
        images[current].classList.replace('opacity-0', 'opacity-100');
        if (counter) counter.textContent = `${current + 1} / ${images.length}`;
    }

    gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => goTo(current - 1));
    gallery.querySelector('[data-gallery-next]').addEventListener('click', () => goTo(current + 1));
}

document.addEventListener('alpine:init', () => {
    Alpine.data('renderRoom', () => ({
        html: '',

        init() {
            this.$watch('$store.flyouts.roomPostId', async (postId) => {
                if (!postId) return;

                this.$store.flyouts.roomLoading = true;

                try {
                    const formData = new FormData();
                    formData.append('action', 'render_room');
                    formData.append('post_id', postId);

                    const response = await fetch(renderRoomAjax.ajax_url, { method: 'POST', body: formData });
                    const data = await response.json();

                    if (data.html) {
                        this.html = data.html;
                        await this.$nextTick();
                        initRoomGallery(this.$el);
                        this.$store.flyouts.open('room');
                    }
                } catch (err) {
                    this.html = '';
                } finally {
                    this.$store.flyouts.roomLoading = false;
                }
            });
        },
    }));
});

//# sourceMappingURL=render-room.js.map
